"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CommonDialog = void 0;
var _commonDialog = _interopRequireDefault(require("./components/common-dialog"));
exports.CommonDialog = _commonDialog["default"];